import React, { useRef } from "react";
import { Box, Card } from "@curves/ui-base";
import useEChart from "@util/hook/useEChart";
import ChartSkeletonLoading from "@icoach/dashboard/ChartSkeletonLoading";

const MessagesLabel = ({ name, marker, value, percent, message }) => {
	return (
		<React.Fragment>
			<strong>{name}</strong>
			<br />
			{`${marker} ${value} 人（${percent}%）`}
			<br />
			<br />
			<span>{message}</span>
		</React.Fragment>
	);
};

/********* 會籍到期時間 *********/
const MembershipExpireTime = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			series: {
				data: [
					{
						itemStyle: { color: "#BE123C" },
						meta: { level: "danger" },
						name: "0-1個月",
						value: 12,
					},
					{
						itemStyle: { color: "#FB7185" },
						meta: { level: "warning" },
						name: "2~3個月",
						value: 20,
					},
					{
						itemStyle: { color: "#5B0F74" },
						meta: { level: "safe" },
						name: "3個月以上",
						value: 68,
					},
				],
				messages: {
					danger: "高續約風險族群",
					warning: "需關注續約狀態",
					safe: "穩定會籍族群\n短期內續約風險低",
				},
				centerValueText: 32,
			},
		},
	} = props;
	const { series = {} } = sourceData;
	const seriesData = series?.data ?? [];
	const messages = series?.messages ?? {};
	const centerValueText = series?.centerValueText ?? "";
	const isLoading = seriesData.length === 0;
	const title = "會籍到期時間";
	const subTitle = "追蹤續約可能指標";

	const option = {
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},
		legend: {
			left: "center",
			bottom: 14,
			textStyle: {
				fontSize: 14,
				fontWeight: 600,
			},
		},
		series: [
			{
				type: "pie",
				radius: ["50%", "65%"],
				center: ["50%", "55%"],
				avoidLabelOverlap: false,
				padAngle: 3,
				itemStyle: {
					borderRadius: 6,
				},
				label: { show: false },
				labelLine: { show: false },
				data: seriesData,
			},
		],
		tooltip: {
			trigger: "item",
			formatter: params => {
				const { name, value, percent, marker, data } = params;
				const level = data.meta.level;
				return <MessagesLabel name={name} value={value} percent={percent} marker={marker} message={messages[level]} />;
			},
		},
		graphic: [
			{
				type: "text",
				left: "center",
				top: "43%",
				style: {
					text: "續約風險",
					fill: "#94A3B8",
					fontSize: 28,
					textAlign: "center",
				},
			},
			{
				type: "text",
				right: "50%",
				top: "52%",
				style: {
					text: centerValueText,
					fill: "#E11D48",
					fontSize: 60,
					fontWeight: 700,
					textAlign: "center",
				},
			},
			{
				type: "text",
				left: "50%",
				top: "52%",
				style: {
					text: "%",
					fill: "#E11D48",
					fontSize: 60,
					fontWeight: 700,
					textAlign: "center",
				},
			},
		],
	};

	useEChart(chartDomRef, option);

	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});

export default MembershipExpireTime;
